import { HeaderWrapper } from './HeaderWrapper';

export default HeaderWrapper;
